import { Component } from '@angular/core';
import { ICON } from '@core/util/icon';
import { Select } from '@ngxs/store';
import { LoadingModalState } from '@state/global/loading-modal/loading-modal.state';

@Component({
	selector: 'app-loading-modal',
	templateUrl: './loading-modal.component.html',
	standalone: false,
})
export class LoadingModalComponent {
	@Select(LoadingModalState.title) title$!: string;
	@Select(LoadingModalState.subtitle) subtitle$!: string;

	constructor() {}
	public ICON = ICON;
}
